module.exports = __webpack_public_path__ + "img/多边形3.2249dae7.svg";